export const PHOTO_UPLOAD_CONSTANTS = {
  SECTION_ID: 'photos',
  TITLE_ID: 'photos-title',
  SECTION_TITLE: '📷 Capture the Magic ✨',
  DESCRIPTION: 'We’d love to see our big day through your eyes! Your memories will help us relive every moment. ❤️',
  UPLOAD_LINK: 'http://photos.app.goo.gl/PHLAjFhrcdLojZSHA',
  BUTTON_TEXT: 'Upload Photos',
  QR_CODE_ALT: 'QR Code to upload wedding photos',
  INSTRUCTION_TEXT: 'Scan the QR code or click the button below to upload your photos',
};